<template>
  <div>
    <FilterSimpleSlot
      :headers="headers"
      :data="show"
      :days="propDays"
      :paginate="paginate"
      :filterPrincipal="filterPrincipal"
      :showPaginator="false"
      @reload="$refs['ref-table-rrhh-attendance-by-department'].refresh()"
      :filter="filters"
    >
      <template #buttons>
        <b-row>
          <b-col md="6" lg="2">
            <b-form-group :label="$t('Filter By')" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                id="filter-by"
                v-model="secondFilter.value"
                :options="secondFilter.options"
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                size="md"
                name="options-second-filter"
                buttons
                @change="handleFilterChange"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" lg="2" v-if="currentModule == globalModules.RRHH">
            <b-form-group :label="$t('Departments')">
              <v-select
                v-model="module_id"
                :options="modulesReal"
                :clearable="false"
                :placeholder="$t('Select Department')"
                label="name"
                :reduce="(val) => val.id"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col md="6" lg="2">
            <b-form-group label="Columnas">
              <v-select
                v-model="showFieldsArray"
                :options="showFields"
                :clearable="false"
                label="label"
                :reduce="(val) => val.key"
                multiple
              />
            </b-form-group>
          </b-col> -->

          <b-col md="3" lg="2" v-if="secondFilter.value == 'week'">
            <b-form-group :label="$t('From')">
              <kendo-datepicker
                class="w-100 rounded form-control-kendo"
                :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                :min="minDate"
                :max="maxDate"
                v-model="initDateSelect"
                :format="'MM/dd/yyyy'"
                name="created_date"
                id="created_date"
              ></kendo-datepicker>
            </b-form-group>
          </b-col>

          <b-col md="3" lg="2" v-if="secondFilter.value == 'week'">
            <b-form-group :label="$t('To')">
              <kendo-datepicker
                class="w-100 rounded form-control-kendo"
                :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                :min="minDate"
                :max="maxDate"
                v-model="hearChange"
                :format="'MM/dd/yyyy'"
                name="created_date"
                id="created_date"
                :disabled="true"
              ></kendo-datepicker>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            lg="1"
            class="d-flex align-items-center"
            v-if="secondFilter.value == 'week'"
          >
            <b-button
              variant="primary"
              class="btn-icon rounded-circle"
              @click="changeWeek(-1)"
            >
              <feather-icon icon="ChevronLeftIcon" size="15" />
            </b-button>
            <b-button
              variant="primary"
              class="btn-icon rounded-circle ml-2"
              @click="changeWeek(1)"
            >
              <feather-icon icon="ChevronRightIcon" size="15" />
            </b-button>
          </b-col>

          <b-col lg="6" v-if="secondFilter.value == 'month'">
            <div class="d-flex">
              <b-form-group :label="$t('Year')" style="width: 120px">
                <v-select
                  v-model="currentYear"
                  :options="years"
                  :clearable="false"
                ></v-select>
              </b-form-group>
              <b-form-group
                :label="$t('Month')"
                class="ml-1"
                style="width: 155px"
              >
                <v-select
                  id="type"
                  label="text"
                  :clearable="false"
                  :options="months"
                  :reduce="(val) => val.value"
                  v-model="currentMonth"
                />
              </b-form-group>
            </div>
          </b-col>

          <b-col lg="3" v-if="secondFilter.value == 'year'">
            <b-form-group :label="$t('Year')">
              <v-select
                v-model="currentYear"
                :options="years"
                :clearable="false"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button
              variant="info"
              class="mt-2"
              v-b-tooltip.hover.top="$t('Download Excel')"
              @click="exportToExcel"
            >
              <feather-icon icon="FileTextIcon" /> Excel
            </b-button>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <div class="icon-container">
                <feather-icon
                  id="help-icon"
                  icon="HelpCircleIcon"
                  size="22"
                  class="text-warning cursor-pointer"
                />
                <b-tooltip target="help-icon" triggers="hover">
                  <div
                    v-for="tag in attendanceTags"
                    :key="tag.index"
                    class="d-flex align-items-center"
                    style="margin-bottom: 5px"
                  >
                    <b-avatar rounded :variant="tag.style" size="22">
                      <span> {{ $t(tag.val) }} </span>
                    </b-avatar>
                    <p class="m-0 ml-1">
                      {{ $t(tag.name) }}
                    </p>
                  </div>
                </b-tooltip>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>

      <template #table>
        <b-table
          v-if="module_id != null"
          ref="ref-table-rrhh-attendance-by-department"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :items="myProvider"
          :fields="tableFields"
          :busy.sync="isBusy"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(name)="data">
            <span class="text-warning"> {{ data.item.name | capitalize }} </span
            ><br />
            <tabler-icon icon="BuildingBankIcon" class="text-primary" />
            <span style="margin-left: 5px; opacity: 0.7">
              {{ data.item.department }}
            </span>
          </template>

          <template #cell(isSchedule)="data">
            <b-badge :variant="data.value ? 'light-primary' : 'light-danger'">
              {{ data.value ? $t("Configurated") : $t("Not configurated") }}
            </b-badge>
            <feather-icon
              v-if="data.value"
              icon="EyeIcon"
              size="18"
              v-b-tooltip.hover.right="$t('View schedule')"
              class="text-success ml-1 cursor-pointer"
              @click="viewSchedule(data.item.employee_id)"
            />
          </template>

          <template #cell(count_attendance)="data">
            <span
              style="font-size: 15px"
              class="cursor-pointer"
              @click="openFractionsModal(data.item)"
            >
              <b-badge variant="light-primary">
                {{ data.item.count_attendance }}
              </b-badge>
            </span>
          </template>

          <template #cell(count_is_late)="data">
            <span style="font-size: 15px" v-if="data.item.isSchedule == 1">
              <b-badge variant="light-primary">
                {{ data.item.count_is_late }}
              </b-badge>
            </span>
            <span v-else> - </span>
          </template>

          <template #cell(count_absence)="data">
            <span style="font-size: 15px" v-if="data.item.isSchedule == 1">
              <b-badge variant="light-primary">
                {{ data.item.count_absence }}
              </b-badge>
            </span>
            <span v-else> - </span>
          </template>

          <template #cell(count_inconsistency)="data">
            <span
              style="font-size: 15px"
              :class="data.item.isSchedule == 1 ? 'cursor-pointer' : ''"
              v-if="data.item.isSchedule == 1"
            >
              <b-badge
                variant="light-warning"
                active
                @click="openModalListAttendanceInconsistencies(data.item)"
              >
                {{ data.item.count_inconsistency }}
              </b-badge>
            </span>
            <span v-else> - </span>
          </template>

          <template #cell(total_attendance)="data">
            <span style="font-size: 15px" v-if="data.item.isSchedule == 1">
              <b-badge variant="light-primary">
                {{ data.item.total_attendance }}
              </b-badge>
            </span>
            <span v-else> - </span>
          </template>

          <template #cell()="data">
            <template v-if="secondFilter.value == 'year'">
              <template v-if="data.value">
                <template v-for="(val, key) in data.value">
                  <div
                    :key="key"
                    v-if="key !== 'total' && key !== 'month' && key !== 'num'"
                  >
                    <b-avatar size="sm" rounded :variant="resolvColor(key)">
                      <span class="text-uppercase"> {{ key }} </span>
                    </b-avatar>
                    <span> : {{ val }} </span>
                    <hr class="m-0" style="border-top: 1px solid rgba(0,0,0,0.05); margin: 3px 0 !important;"/>
                  </div>
                </template>
                <div v-if="data.value.total !== undefined" class="mt-1">
                  <b-avatar size="sm" rounded variant="light-warning">
                    <span class="text-uppercase"> #</span>
                  </b-avatar>
                  <span> : {{ data.value.total }} </span>
                </div>
              </template>
            </template>
            <div v-else
              class="d-flex text-center align-items-center justify-content-center"
              style="margin-bottom: 7px; margin-top: 4px"
            >
              <!-- {{ data.value }} -->
              <span
                v-if="
                  ((disableDay(data.value, data.item.schedule) ||
                    data.item.schedule.length == 0) &&
                    data.value.is_holiday == 0) ||
                  data.value.es_vacacion == 1
                "
                :class="data.item.isSchedule == 1 ? 'cursor-pointer' : ''"
                @click="
                  data.item.isSchedule
                    ? detailAttendance(data.item, data.value)
                    : null
                "
              >
                <b-avatar
                  rounded
                  size="28"
                  :variant="resolveStyleAttendance(data.value, 'in')"
                >
                  <span>
                    {{ $t(resolveValueAttendance(data.value, "in")) }}
                  </span>
                </b-avatar>
              </span>

              <span v-else-if="data.value.is_holiday == 1">
                <b-avatar rounded size="28" variant="light-info">
                  <span> F </span>
                </b-avatar>
              </span>
              <span v-else>
                <b-avatar rounded size="28" variant="light-secondary">
                  <span>NT </span>
                </b-avatar>
              </span>
            </div>
          </template>
        </b-table>
      </template>
    </FilterSimpleSlot>

    <b-modal
      hide-footer
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
      v-model="modalSchedule"
      :title="$t('Employee Schedule')"
    >
      <PersonalSchedule
        :employeeId="employeeId"
        :type="'modal'"
        :onlyView="true"
        @close="modalSchedule = false"
      />
    </b-modal>
    <DetailAttendanceModal
      v-if="showDetailAttendanceModal"
      :markId="markId"
      :date="dateSelected"
      :employeeId="employeeId"
      :employeeName="employeeName"
      @hideModal="showDetailAttendanceModal = false"
      @stored="
        $refs['ref-table-rrhh-attendance-by-department'].refresh(),
          (showDetailAttendanceModal = false)
      "
    />

    <ModalListAttendanceInconsistencies
      v-if="showModalListAttendanceInconsistencies"
      :personal="selectedPersonal"
      @hidden="closeModalListAttendanceInconsistencies"
      @stored="$refs['ref-table-rrhh-attendance-by-department'].refresh()"
    />
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";
import ModaImportExcel from "@/views/rrhh/views/attendance/components/ModalImportExcel.vue";
import PersonalSchedule from "@/views/rrhh/views/employees/components/information/schedule/PersonalSchedule.vue";
import DetailAttendanceModal from "@/views/commons/employee_attendance/modals/DetailAttendanceModal.vue";
import { ClipboardIcon, ClipboardCopyIcon } from "vue-tabler-icons";
import ModalListAttendanceInconsistencies from "@/views/commons/employee_attendance/justifications/modals/ModalListAttendanceInconsistencies.vue";
import { getDayName } from "@/helpers/helpers.js";

import Fields from "@/views/commons/employee_attendance/data/fields.data.js";
import FilterSimpleSlot from "@/views/commons/filter-slot/FilterReportSimpleSlot.vue";
import AttendanceTags from "@/views/commons/employee_attendance/data/attendanceTags.js";
import { modules as globalModules } from "@core/utils/modules.js";
import Filters from "@/views/commons/employee_attendance/data/filters.asistencia.administrativo.js";

export default {
  name: "AttendanceReportTable",
  props: ["global"],
  components: {
    FilterSimpleSlot,
    ModaImportExcel,
    ClipboardIcon,
    ClipboardCopyIcon,
    PersonalSchedule,
    DetailAttendanceModal,
    ModalListAttendanceInconsistencies,
  },
  data() {
    return {
      // filters: Filters,
      filters: [],
      showFieldsArray: [],
      globalModules,
      showDetailAttendanceModal: false,
      employeeName: "",
      show: [],
      min: new Date(1950, 0, 1, 0, 0, 0),
      max: new Date(3049, 11, 31, 24, 0, 0),
      week: 0,
      initDate: moment().startOf("week").add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().endOf("week").add(1, "days").format("YYYY-MM-DD"),
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
      initDateSelect: "",
      hearChange: "",
      days: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
      },
      selectedPersonal: {
        personal_id: "",
        name: "",
      },
      modules: [],
      module_id: null,
      users: [],
      headers: [
        {
          name: "User",
        },
      ],
      propDays: [],
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      fields: Fields,
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      secondFilter: {
        options: [
          {
            text: "Week",
            value: "week",
          },
          {
            text: "Month",
            value: "month",
          },
          {
            text: "Year",
            value: "year",
          },
        ],
        value: "week",
      },
      modalSchedule: false,
      employeeId: null,
      dateSelected: null,
      employeeName: null,
      attendanceTags: AttendanceTags,
      showModalListAttendanceInconsistencies: false,
      objLength: 0,
      sortInBack: null,

      snapshotSortBy: null,
      snapshotOrderBy: null,
      snapshotSortInBack: null,
    };
  },
  created() {
    this.addPreloader();
    this.secondFilter.options.map((op) => (op.text = this.$t(op.text)));
    this.generateLastTenYears();
    this.initDateSelect = this.initDate;
    this.loadAreas();
  },

  mounted() {
    const saved = localStorage.getItem("showFieldsArray");
    if (saved) {
      this.showFieldsArray = JSON.parse(saved);
    } else {
      this.showFieldsArray = this.showFields.map((f) => f.key);
    }
  },
  methods: {
    // helpers
    getDayName,

    disableDay(date, schedule) {
      const day = this.getDayName(date.date);

      if (schedule.length == 0) return true;

      switch (day) {
        case "sunday":
          return schedule[0].work_sunday == 1 ? false : true;
        case "monday":
          return schedule[0].work_monday == 1 ? false : true;
        case "tuesday":
          return schedule[0].work_tuesday == 1 ? false : true;
        case "wednesday":
          return schedule[0].work_wednesday == 1 ? false : true;
        case "thursday":
          return schedule[0].work_thursday == 1 ? false : true;
        case "friday":
          return schedule[0].work_friday == 1 ? false : true;
        case "saturday":
          return schedule[0].work_saturday == 1 ? false : true;
      }
    },

    openModalListAttendanceInconsistencies(data) {
      let nStartDate = this.initDate;
      let nEndDate = this.endDate;
      if (this.secondFilter.value == "month") {
        const dayOfMonth = moment(
          `${this.currentYear}-${this.currentMonth}-01`,
          "YYYY-MM-DD"
        );
        const endOfMonth = dayOfMonth.clone().endOf("month");
        nStartDate = dayOfMonth.format("YYYY-MM-DD");
        nEndDate = endOfMonth.format("YYYY-MM-DD");
      }
      this.selectedPersonal = {
        personal_id: data.employee_id,
        name: data.name,
        startDate: nStartDate,
        endDate: nEndDate,
      };
      this.showModalListAttendanceInconsistencies = true;
    },

    closeModalListAttendanceInconsistencies() {
      this.selectedPersonal = {};
      this.showModalListAttendanceInconsistencies = false;
    },

    async myProvider(ctx) {
      let sortBy;
      let sortInBack;
      switch (ctx.sortBy) {
        case "name":
          sortBy = 3;
          break;
        case "total_attendance":
          sortInBack = 13;
          break;
        case "count_inconsistency":
          sortInBack = 10;
          break;
        case "count_absence":
          sortInBack = 11;
          break;
        case "count_is_late":
          // sortInBack = this.objLength;
          sortInBack = 12;
          break;
      }

      this.sortInBack = sortInBack;

      let nStartDate = this.initDate;
      let nEndDate = this.endDate;

      if (this.secondFilter.value == "month") {
        const dayOfMonth = moment(
          `${this.currentYear}-${this.currentMonth}-01`,
          "YYYY-MM-DD"
        );
        const endOfMonth = dayOfMonth.clone().endOf("month");
        nStartDate = dayOfMonth.format("YYYY-MM-DD");
        nEndDate = endOfMonth.format("YYYY-MM-DD");
      } else if (this.secondFilter.value == "year") {
        nStartDate = moment(`${this.currentYear}-01-01`).format("YYYY-MM-DD");
        nEndDate = moment(`${this.currentYear}-12-31`).format("YYYY-MM-DD");
      }
      try {
        this.hearChange = this.endDate;
        this.addPreloader();

        this.snapshotSortBy = sortBy ?? 3;
        this.snapshotOrderBy = ctx.sortDesc ? "desc" : "asc";
        this.snapshotSortInBack = sortInBack;

        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          filterType: this.secondFilter.value,
          startDate: nStartDate,
          endDate: nEndDate,
          search: this.filterPrincipal.model,
          departmentId: this.module_id,
          currentMonth: this.currentMonth,
          currentYear: this.currentYear,

          sortBy: this.snapshotSortBy,
          orderBy: this.snapshotOrderBy,
          sortInBack: this.snapshotSortInBack,
        };

        const { data } = await AttendanceService.getAttendanceReport(params);

        if (this.secondFilter.value == "year") {
          this.objLength = Object.keys(data.data.data[0]).length || 0;
          
          this.fields = [
            { key: "name", label: "User", visible: true },
          ];
          
          let months = ["_01", "_02", "_03", "_04", "_05", "_06", "_07", "_08", "_09", "_10", "_11", "_12"];
          let monthNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];
          
          months.forEach((m, index) => {
            this.fields.push({
              key: m,
              label: monthNames[index],
              thClass: "text-center",
              tdClass: "text-center",
              visible: true,
              dynamic: true,
            });
          });
          
          this.fields.push({
            key: "totals",
            label: "Total",
            thClass: "text-center",
            tdClass: "text-center",
            visible: true,
            dynamic: true,
          });

        } else {
          this.objLength = Object.keys(data.data.data[0]).length || 0;
          this.fields = [...Fields];
          data.days.map((item) =>
            this.fields.push({
              key: item,
              label: item,
              thClass: "text-center",
              tdClass: "text-center",
              visible: true,
              dynamic: true,
            })
          );
        }

        this.paginate.from = data.data.from;
        this.paginate.to = data.data.to;
        this.paginate.of = data.data.total;
        this.paginate.perPage = data.data.per_page;
        this.paginate.currentPage = data.data.current_page;

        return data.data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    handleFilterChange() {
      if (this.secondFilter.value == "week") {
        this.initDate = moment()
          .startOf("week")
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.endDate = moment()
          .endOf("week")
          .add(1, "days")
          .format("YYYY-MM-DD");

        this.initDateSelect = this.initDate;
      } else {
        this.currentMonth = new Date().getMonth() + 1;
        this.currentYear = new Date().getFullYear();
      }
      this.$refs["ref-table-rrhh-attendance-by-department"].refresh();
    },

    resolveValueAttendance(day, check) {
      if (day.new_status == null) {
        return null;
      }
      if (day.is_late)
        return this.attendanceTags.filter((tag) => tag.index == 10)[0].val;
      return this.attendanceTags.filter((tag) => tag.index == day.new_status)[0]
        .val;
    },

    resolveStyleAttendance(day) {
      if (day.new_status == null) {
        return null;
      }
      return this.attendanceTags.filter((tag) => tag.index == day.new_status)[0]
        .style;
    },

    generateLastTenYears() {
      this.years = [];

      for (var i = this.currentYear - 5; i <= this.currentYear + 5; i++) {
        this.years.push(i);
      }
    },

    viewSchedule(employeeId) {
      this.modalSchedule = true;
      this.employeeId = employeeId;
    },

    detailAttendance(data, day) {
      this.markId = day.id;
      this.dateSelected = day.date;
      this.employeeId = data.employee_id;
      this.employeeName = data.name;
      this.showDetailAttendanceModal = true;
    },

    changeWeek(week) {
      this.week = this.week + week;
      this.initDate = moment()
        .startOf("week")
        .add(this.week, "week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.endDate = moment()
        .endOf("week")
        .add(this.week, "week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.initDateSelect = this.initDate;
      this.hearChange = this.endDate;
    },

    async loadAreas() {
      const { data } = await AttendanceService.listSchedulesAreas();
      data.unshift({
        id: 0,
        name: this.$t("All"),
      });

      this.modules = data;
      if (this.currentModule == globalModules.RRHH) {
        this.module_id = 0;
      } else {
        this.module_id = this.currentModule;
      }
      // if ([1, 2].includes(this.currentUser.role_id)) {
      //   this.module_id = 0;
      // } else {
      //   this.module_id = this.$route.matched[0].meta?.module;
      // }
    },

    resolvColor(key) {
      const tag = this.attendanceTags.find((t) => t.val === key);
      return tag ? tag.style : "light-info";
    },

    async exportToExcel() {
      this.addPreloader();
      try {
        // let nStartDate = this.initDate;
        // let nEndDate = this.endDate;

        // if (this.secondFilter.value == "month") {
        //   const dayOfMonth = moment(
        //     `${this.currentYear}-${this.currentMonth}-01`,
        //     "YYYY-MM-DD"
        //   );
        //   const endOfMonth = dayOfMonth.clone().endOf("month");
        //   nStartDate = dayOfMonth.format("YYYY-MM-DD");
        //   nEndDate = endOfMonth.format("YYYY-MM-DD");
        // }
        // const params = {
        //   start_dat: nStartDate,
        //   end_date: nEndDate,
        // };
        let nStartDate = this.initDate;
        let nEndDate = this.endDate;

        if (this.secondFilter.value == "month") {
          const dayOfMonth = moment(
            `${this.currentYear}-${this.currentMonth}-01`,
            "YYYY-MM-DD"
          );
          const endOfMonth = dayOfMonth.clone().endOf("month");
          nStartDate = dayOfMonth.format("YYYY-MM-DD");
          nEndDate = endOfMonth.format("YYYY-MM-DD");
        } else if (this.secondFilter.value == "year") {
          nStartDate = moment(`${this.currentYear}-01-01`).format("YYYY-MM-DD");
          nEndDate = moment(`${this.currentYear}-12-31`).format("YYYY-MM-DD");
        }

        const params = {
          page: 1,
          perpage: 50,
          filterType: this.secondFilter.value,
          startDate: nStartDate,
          endDate: nEndDate,
          search: this.filterPrincipal.model,
          departmentId: this.module_id,
          currentMonth: this.currentMonth,
          currentYear: this.currentYear,
          sortBy: this.snapshotSortBy,
          orderBy: this.snapshotOrderBy,
          sortInBack: this.snapshotSortInBack,
        };

        const response = await AttendanceService.exportToExcel(params);

        // Extraer nombre de archivo desde el header Content-Disposition
        const disposition = response.headers["content-disposition"];
        let filename = "vacaciones.xlsx";
        if (disposition && disposition.includes("filename=")) {
          filename = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "") // eliminar comillas si hay
            .trim();
        }

        this.forceFileDownload(response.data, filename);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },

  watch: {
    initDateSelect(newVal, oldVal) {
      this.propDays = [
        {
          date: moment(newVal).startOf("week").add(1, "days").format("MM-DD"),
          prefix: "mon",
        },
        {
          date: moment(newVal).startOf("week").add(2, "days").format("MM-DD"),
          prefix: "tue",
        },
        {
          date: moment(newVal).startOf("week").add(3, "days").format("MM-DD"),
          prefix: "wed",
        },
        {
          date: moment(newVal).startOf("week").add(4, "days").format("MM-DD"),
          prefix: "thu",
        },
        {
          date: moment(newVal).startOf("week").add(5, "days").format("MM-DD"),
          prefix: "fri",
        },
        {
          date: moment(newVal).startOf("week").add(6, "days").format("MM-DD"),
          prefix: "sat",
        },
        {
          date: moment(newVal).startOf("week").add(7, "days").format("MM-DD"),
          prefix: "sun",
        },
      ];
      this.initDate = moment(newVal)
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.endDate = moment(newVal)
        .startOf("week")
        .add(7, "days")
        .format("YYYY-MM-DD");
      var a = moment(newVal).startOf("week").add(1, "days");
      var b = moment().startOf("week").add(1, "days");
      this.week = a.diff(b, "weeks");
    },
    module_id(newVal, oldVal) {
      this.users = [];
    },
    currentYear(oldValue, newValue) {
      if (!newValue) {
        return;
      }
    },
    showFieldsArray: {
      deep: true,
      handler(val) {
        localStorage.setItem("showFieldsArray", JSON.stringify(val));
      },
    },
  },
  computed: {
    currentModule() {
      return this.$route.matched[0].meta?.module;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    modulesReal() {
      return this.modules;
    },
    showFields() {
      return this.fields.filter((item) => item.visible && !item.dynamic);
    },
    tableFields() {
      return this.fields.filter(
        (item) => this.showFieldsArray.includes(item.key) || item.dynamic // dinámicos siempre visibles
      );
    },
    months() {
      return [
        {
          value: 1,
          text: this.$options.filters.capitalize(this.$t("january")),
        },
        {
          value: 2,
          text: this.$options.filters.capitalize(this.$t("february")),
        },
        { value: 3, text: this.$options.filters.capitalize(this.$t("march")) },
        { value: 4, text: this.$options.filters.capitalize(this.$t("april")) },
        { value: 5, text: this.$options.filters.capitalize(this.$t("may")) },
        { value: 6, text: this.$options.filters.capitalize(this.$t("june")) },
        { value: 7, text: this.$options.filters.capitalize(this.$t("july")) },
        { value: 8, text: this.$options.filters.capitalize(this.$t("august")) },
        {
          value: 9,
          text: this.$options.filters.capitalize(this.$t("september")),
        },
        {
          value: 10,
          text: this.$options.filters.capitalize(this.$t("october")),
        },
        {
          value: 11,
          text: this.$options.filters.capitalize(this.$t("november")),
        },
        {
          value: 12,
          text: this.$options.filters.capitalize(this.$t("december")),
        },
      ];
    },
  },
};
</script>
<style lang="scss">
// dark theme
.dark-layout .form-control-kendo {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.357rem;
  width: 100%;
  min-height: calc(1.57em + 0.75rem + 2px);
}
.dark-layout .k-select {
  border-color: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
}

// light theme

.form-control-kendo {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.357rem;
  width: 100%;
  min-height: calc(1.57em + 0.75rem + 2px);
}
.dark-layout .k-datepicker:hover {
  background-color: #2c2828 !important;
}
.icon-container {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
